<template>
  <v-card class="pa-4" outlined :loading="cameraLoading">
    <web-cam
      ref="webcam"
      :device-id="deviceId"
      width="100%"
      @started="onStarted"
      @stopped="onStopped"
      @error="onError"
      @cameras="onCameras"
      @camera-change="onCameraChange"
      style="height: auto;min-height: 295px;"
    />
    <div style="text-align: start;">
      <v-btn icon @click="swapCamera"><v-icon>mdi-camera-switch</v-icon></v-btn>
    </div>
    <v-card-text style="color: red;">{{ errorText }}</v-card-text>

    <div class="col-md-12">
      <v-btn :loading="loading" color="primary" :disabled="cameraLoading" class="btn btn-primary" @click="onCapture">{{
        $t("faceId.capturePhoto")
      }}</v-btn>
      <!-- <v-btn class="btn btn-danger" @click="onStop">Stop Camera</v-btn>
      <v-btn class="btn btn-success" @click="onStart">Start Camera</v-btn> -->
    </div>
  </v-card>
</template>
<script>
import { WebCam } from "vue-web-cam";
export default {
  components: {
    WebCam
  },
  props: {
    type: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      img: null,
      camera: null,
      deviceId: null,
      devices: [],
      deviceIndex: 0,
      cameraLoading: true,
      errorText: "",
    };
  },
  computed: {
    device: function() {
      return this.devices.find(n => n.deviceId === this.deviceId);
    }
  },
  watch: {
    camera: function(id) {
      this.deviceId = id;
    },
    devices: function() {
      // Once we have a list select the first one
      const [first, ...tail] = this.devices;
      if (first) {
        this.camera = first.deviceId;
        this.deviceId = first.deviceId;
      }
    }
  },
  methods: {
    swapCamera() {
      if(this.devices.length <= 1){
        return;
      }
      this.deviceIndex = (this.deviceIndex + 1) % this.devices.length;
      this.cameraLoading = true; // Trigger loading UI while switching
      this.deviceId = this.devices[this.deviceIndex].deviceId;
    },
    onCapture() {
      this.img = this.$refs.webcam.capture();
      if (this.type == "verifyFaceId") {
        this.verifyFaceId(this.img);
      } else if (this.type == "setFaceId") {
        this.setFaceId(this.img);
      } else if (this.type == "disableFaceId") {
        this.disableFaceId(this.img);
      } else if(this.type == "captureImage"){
        this.$emit("onCapture",this.dataURItoBlob(this.img));
      }
    },
    onStarted(stream) {
      this.cameraLoading = false;
      this.errorText = "";
    },
    onStopped(stream) {
      this.cameraLoading = true;
    },
    onStop() {
      this.$refs.webcam.stop();
    },
    onStart() {
      this.cameraLoading = true;
      this.errorText = "";
      this.$refs.webcam.start();
    },
    onError(error) {
      console.log("On Error Event", error);
      this.cameraLoading = false;
      this.errorText = error.message || error;
    },
    onCameras(cameras) {
      this.getReadableCameras(cameras => {
        this.devices = cameras;
      });
    },
    onCameraChange(deviceId) {
      this.deviceId = deviceId;
      this.camera = deviceId;
    },
    getReadableCameras(callback) {
      navigator.mediaDevices.enumerateDevices().then(devices => {
        const videoInputs = devices.filter(d => d.kind === "videoinput");
        const readable = [];
        let checked = 0;
        const total = videoInputs.length;
        if (total === 0) {
          callback([]);
          return;
        }
        videoInputs.forEach(device => {
          navigator.mediaDevices
            .getUserMedia({
              video: { deviceId: { exact: device.deviceId } },
              audio: false
            })
            .then(stream => {
              readable.push(device);
              stream.getTracks().forEach(track => track.stop());
            })
            .catch(err => {})
            .finally(() => {
              checked++;
              if (checked === total) {
                callback(readable);
              }
            });
        });
      });
    },
    setFaceId(image) {
      this.loading = true;
      const data = new FormData();
      var blob = this.dataURItoBlob(image);
      data.append("faceIdImage", blob, "faceIdImage.jpeg");
      this.axios
        .post("Account/SetFaceId", data)
        .then(res => {
          if (res.data.statusCode == 1) {
            this.$swal.fire({
              title: this.$t("operationAccomplishedSuccessfully"),
              text: "",
              icon: "success",
              confirmButtonText: this.$t("close"),
              toast: true,
              position: "bottom-start",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: toast => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              }
            });
            //emit event to parent component
            this.$emit("onFaceidDone");
          } else if (res.data.statusCode == 2) {
            this.$swal.fire({
              title: this.$t("faceId.fileTypeNotSupported"),
              text: res.data.detail,
              icon: "warning",
              confirmButtonText: this.$t("close")
            });
          } else if (res.data.statusCode == 3) {
            this.$swal.fire({
              title: this.$t("faceId.fileSizeExceeded"),
              text: res.data.detail,
              icon: "warning",
              confirmButtonText: this.$t("close")
            });
          } else if (res.data.statusCode == 4) {
            this.$swal.fire({
              title: this.$t("faceId.alreadyEnabled"),
              text: res.data.detail,
              icon: "warning",
              confirmButtonText: this.$t("close")
            });
          } else if (res.data.statusCode == 5) {
            this.$swal.fire({
              title:this. $t("faceId.faceInvalid"),
              text: res.data.detail,
              icon: "warning",
              confirmButtonText: this.$t("close")
            });
          } else if (res.data.statusCode == 6) {
            this.$swal.fire({
              title:this. $t("faceId.errorSaveImage"),
              text: res.data.detail,
              icon: "warning",
              confirmButtonText: this.$t("close")
            });
          } else {
            this.$swal.fire({
              title: res.data.title,
              text: res.data.detail,
              icon: "error",
              confirmButtonText: this.$t("close")
            });
          }
        })
        .catch(err => {
          this.$swal.fire({
            title: this.$t("AnErrorOccurredDuringTheProcess"),
            text:  err.response.data.detail,
            icon: "error",
            confirmButtonText: this.$t("close")
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    verifyFaceId(image) {
      this.loading = true;
      const data = new FormData();
      var blob = this.dataURItoBlob(image);
      data.append("faceIdImage", blob, "faceIdImage.jpeg");
      this.axios
        .post("Account/VerifyFaceId", data)
        .then(res => {
          if (res.data.statusCode == 1) {
            this.$swal.fire({
              title: this.$t("operationAccomplishedSuccessfully"),
              text: "",
              icon: "success",
              confirmButtonText: this.$t("close"),
              toast: true,
              position: "bottom-start",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: toast => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              }
            });
            //emit event to parent component
            this.$emit("onFaceidDone",blob);
          } else if (res.data.statusCode == 2) {
            this.$swal.fire({
              title: this. $t("faceId.fileTypeNotSupported"),
              text: res.data.detail,
              icon: "warning",
              confirmButtonText: this.$t("close")
            });
          } else if (res.data.statusCode == 3) {
            this.$swal.fire({
              title:this. $t("faceId.fileSizeExceeded"),
              text: res.data.detail,
              icon: "warning",
              confirmButtonText: this.$t("close")
            });
          } else if (res.data.statusCode == 4) {
            this.$swal.fire({
              title:this.$t("faceId.faceIdNotEnabled"),
              text: res.data.detail,
              icon: "warning",
              confirmButtonText: this.$t("close")
            });
          } else if (res.data.statusCode == 5) {
            this.$swal.fire({
              title: this.$t("faceId.cannotFindFaceIdImage"),
              text: res.data.detail,
              icon: "warning",
              confirmButtonText: this.$t("close")
            });
          } else if (res.data.statusCode == 6) {
            this.$swal.fire({
              title: this.$t("faceId.faceInvalid"),
              text: res.data.detail,
              icon: "warning",
              confirmButtonText: this.$t("close")
            });
          } else {
            this.$swal.fire({
              title: res.data.title,
              text: res.data.detail,
              icon: "error",
              confirmButtonText: this.$t("close")
            });
          }
        })
        .catch(err => {
          this.$swal.fire({
            title: this.$t("AnErrorOccurredDuringTheProcess"),
            text: err.response.data.detail,
            icon: "error",
            confirmButtonText: this.$t("close")
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    disableFaceId(image) {
      this.loading = true;
      const data = new FormData();
      var blob = this.dataURItoBlob(image);
      data.append("faceIdImage", blob, "faceIdImage.jpeg");
      this.axios
        .post("Account/DisableFaceId", data)
        .then(res => {
          if (res.data.statusCode == 1) {
            this.$swal.fire({
              title: this.$t("operationAccomplishedSuccessfully"),
              text: "",
              icon: "success",
              confirmButtonText: this.$t("close"),
              toast: true,
              position: "bottom-start",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: toast => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              }
            });
            //emit event to parent component
            this.$emit("onFaceidDone");
          } else if (res.data.statusCode == 2) {
            this.$swal.fire({
              title:this. $t("faceId.fileTypeNotSupported"),
              text: res.data.detail,
              icon: "warning",
              confirmButtonText: this.$t("close")
            });
          } else if (res.data.statusCode == 3) {
            this.$swal.fire({
              title: this.$t("faceId.fileSizeExceeded"),
              text: res.data.detail,
              icon: "warning",
              confirmButtonText: this.$t("close")
            });
          } else if (res.data.statusCode == 4) {
            this.$swal.fire({
              title: this. $t("faceId.faceIdNotEnabled"),
              text: res.data.detail,
              icon: "warning",
              confirmButtonText: this.$t("close")
            });
          } else if (res.data.statusCode == 5) {
            this.$swal.fire({
              title:  this.$t("faceId.cannotFindFaceIdImage"),
              text: res.data.detail,
              icon: "warning",
              confirmButtonText: this.$t("close")
            });
          } else if (res.data.statusCode == 6) {
            this.$swal.fire({
              title: this. $t("faceId.faceInvalid"),
              text: res.data.detail,
              icon: "warning",
              confirmButtonText: this.$t("close")
            });
          } else {
            this.$swal.fire({
              title: res.data.title,
              text: res.data.detail,
              icon: "error",
              confirmButtonText: this.$t("close")
            });
          }
        })
        .catch(err => {
          this.$swal.fire({
            title: this.$t("AnErrorOccurredDuringTheProcess"),
            text: err.response.data.detail,
            icon: "error",
            confirmButtonText: this.$t("close")
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    dataURItoBlob(dataURI) {
      var byteString = atob(dataURI.split(",")[1]);
      var mimeString = dataURI
        .split(",")[0]
        .split(":")[1]
        .split(";")[0];
      var ab = new ArrayBuffer(byteString.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      var blob = new Blob([ab], { type: mimeString });
      return blob;
    }
  }
};
</script>
